// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dtco-overview-page .header-text {
  font-family: Maersk Headline, sans-serif;
  font-size: 36px;
  font-weight: 300;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;
}
.dtco-overview-page .guide-info-icon {
  position: absolute;
  top: 32px;
  left: 23rem;
  color: var(--color-maersk-blue);
  margin-left: 7px;
  cursor: pointer;
}
.dtco-overview-page .proposalDetails {
  z-index: 2;
}
.dtco-overview-page .specialcaseSection .MultiSelect__control .status-label {
  display: none;
}
.dtco-overview-page .specialcaseSection .MultiSelect__control .dtco-performa-header {
  padding-left: 5px !important;
}
.dtco-overview-page .dtco-iteration {
  z-index: 2;
  border: solid 0.5px var(--color-maersk-blue);
  margin-top: 1rem;
  background: var(--color-white);
  border-radius: 3px;
}
.dtco-overview-page .dtco-iteration .iteration-section {
  background: var(--color-light-blue);
  padding: 10px 15px;
  border-radius: 3px;
}
.dtco-overview-page .dtco-iteration .iteration-section .status-label {
  border-radius: 4px;
  padding: 1px 7px;
  font-size: 11px;
  margin-top: 2px;
}
.dtco-overview-page .dtco-iteration .iteration-section .status-APPROVED {
  background-color: var(--status-approved);
}
.dtco-overview-page .dtco-iteration .iteration-section .status-Default {
  background-color: var(--status-default);
  color: #083d64;
}
.dtco-overview-page .dtco-iteration .iteration-section .status-ACTIVE {
  background-color: var(--status-active);
  color: #115211;
}
.dtco-overview-page .dtco-iteration .iteration-section .status-APPROVAL {
  background-color: var(--status-approval);
}
.dtco-overview-page .dtco-iteration .iteration-section .status-PLANNING {
  background-color: var(--status-planning);
}
.dtco-overview-page .dtco-iteration .iteration-section .status-SCHEDULING {
  background-color: var(--status-scheduling);
}
.dtco-overview-page .dtco-iteration .iteration-section .status-EXPIRED {
  background-color: var(--status-expired);
}
.dtco-overview-page .dtco-iteration .iteration-section .status-DESIGN {
  background-color: var(--status-design);
  color: rgb(41, 86, 83);
}
.dtco-overview-page .dtco-iteration .iteration-section .option-disabled {
  opacity: 0.5;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-performa-header {
  padding-left: 24px;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-performa-header .dtco-roation-name {
  margin: 0;
  font-size: var(--font-size-md);
}
.dtco-overview-page .dtco-iteration .iteration-section .css-1xc3v61-indicatorContainer {
  cursor: pointer;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-service-name {
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--color-maersk-blue);
  padding: 5px 5px;
  border-radius: 0px;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-run-btn {
  margin-top: 24px;
}
.dtco-overview-page .dtco-iteration .iteration-section .MultiSelect__menu-list {
  padding: 5px !important;
  margin: 0px !important;
  border: 1px solid #e0e0e0;
}
.dtco-overview-page .dtco-iteration .iteration-section .MultiSelect__option:last-child {
  border-bottom: 1px solid #e0e0e0;
}
.dtco-overview-page .dtco-iteration .iteration-section .btn-run {
  height: 36px !important;
}
.dtco-overview-page .dtco-iteration .iteration-section .MultiSelect__option:nth-child(1) {
  border-top: 1px solid #e0e0e0;
}
.dtco-overview-page .dtco-iteration .iteration-section .MultiSelect__option--is-selected {
  background-color: #d7f2fb !important;
}
.dtco-overview-page .dtco-iteration .iteration-section .MultiSelect__value-container {
  height: 36px;
  overflow-x: hidden !important;
  overflow-y: auto;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-handle-group {
  position: relative;
  cursor: pointer;
  font-weight: bold;
  padding: 0px 12px;
  align-content: center;
  background: #f1f6f9;
  border-radius: 0px;
  margin-bottom: 4px;
  height: 36px;
  transition: background-color 0.3s;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-handle-group .dtco-icon {
  position: absolute;
  top: 1px;
  right: 10px;
  font-size: 1.5rem;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-performa-option {
  padding: 10px 12px;
  border-radius: 4px;
  margin-bottom: 2px;
  transition: background-color 0.3s;
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-performa-option-active {
  background-color: var(--performa-option-active);
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-performa-option-active:hover {
  background-color: var(--performa-option-hover);
}
.dtco-overview-page .dtco-iteration .iteration-section .dtco-performa-option-disabled {
  background-color: var(--performa-option-disabled);
  color: var(--performa-option-disabled-color) !important;
  cursor: not-allowed;
  pointer-events: all !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/DtcoOverviewPage/DtcoOverviewPage.scss","webpack://./src/Styles/mixins.scss"],"names":[],"mappings":"AAGE;ECFA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;ADCF;AADE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AAGJ;AAAE;EACE,UAAA;AAEJ;AAEM;EACE,aAAA;AAAR;AAEM;EACE,4BAAA;AAAR;AAIE;EACE,UAAA;EACA,4CAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;AAFJ;AAII;EACE,mCAAA;EACA,kBAAA;EACA,kBAAA;AAFN;AAIM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAFR;AAKM;EACE,wCAAA;AAHR;AAMM;EACE,uCAAA;EACA,cAAA;AAJR;AAOM;EACE,sCAAA;EACA,cAAA;AALR;AAQM;EACE,wCAAA;AANR;AASM;EACE,wCAAA;AAPR;AAUM;EACE,0CAAA;AARR;AAWM;EACE,uCAAA;AATR;AAYM;EACE,sCAAA;EACA,sBAAA;AAVR;AAYM;EACE,YAAA;AAVR;AAaM;EACE,kBAAA;AAXR;AAYQ;EACE,SAAA;EACA,8BAAA;AAVV;AAcM;EACE,eAAA;AAZR;AAeM;EACE,8BAAA;EACA,gBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;AAbR;AAgBM;EACE,gBAAA;AAdR;AAiBM;EACE,uBAAA;EACA,sBAAA;EACA,yBAAA;AAfR;AAkBM;EACE,gCAAA;AAhBR;AAmBM;EACE,uBAAA;AAjBR;AAoBM;EACE,6BAAA;AAlBR;AAqBM;EACE,oCAAA;AAnBR;AAsBM;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AApBR;AAuBM;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,iCAAA;AArBR;AAuBQ;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;AArBV;AAyBM;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;AAvBR;AA0BM;EACE,+CAAA;AAxBR;AA2BM;EACE,8CAAA;AAzBR;AA4BM;EACE,iDAAA;EACA,uDAAA;EACA,mBAAA;EACA,8BAAA;AA1BR","sourcesContent":["@use \"../../Styles/mixins.scss\";\n\n.dtco-overview-page {\n  .header-text {\n    @include mixins.header-font;\n  }\n  .guide-info-icon{\n    position:absolute;\n    top: 32px;\n    left: 23rem;\n    color: var(--color-maersk-blue);\n    margin-left: 7px;\n    cursor: pointer;\n  }\n\n  .proposalDetails {\n    z-index: 2;\n  }\n  .specialcaseSection{\n    .MultiSelect__control{\n      .status-label{\n        display: none;\n      }\n      .dtco-performa-header {\n        padding-left: 5px !important;\n    }\n    }\n  }\n  .dtco-iteration {\n    z-index: 2;\n    border: solid 0.5px var(--color-maersk-blue);\n    margin-top: 1rem;\n    background: var(--color-white);\n    border-radius: 3px;\n\n    .iteration-section {\n      background: var(--color-light-blue);\n      padding: 10px 15px;\n      border-radius: 3px;\n\n      .status-label {\n        border-radius: 4px;\n        padding: 1px 7px;\n        font-size: 11px;\n        margin-top: 2px;\n      }\n\n      .status-APPROVED {\n        background-color: var(--status-approved);\n      }\n\n      .status-Default {\n        background-color: var(--status-default);\n        color: #083d64;\n      }\n\n      .status-ACTIVE {\n        background-color: var(--status-active);\n        color: #115211;\n      }\n\n      .status-APPROVAL {\n        background-color: var(--status-approval);\n      }\n\n      .status-PLANNING {\n        background-color: var(--status-planning);\n      }\n\n      .status-SCHEDULING {\n        background-color: var(--status-scheduling);\n      }\n\n      .status-EXPIRED {\n        background-color: var(--status-expired);\n      }\n\n      .status-DESIGN {\n        background-color: var(--status-design);\n        color: rgb(41, 86, 83)\n      }\n      .option-disabled {\n        opacity: 0.5;\n      }\n\n      .dtco-performa-header {\n        padding-left: 24px;\n        .dtco-roation-name {\n          margin: 0;\n          font-size: var(--font-size-md)\n        }\n      }\n\n      .css-1xc3v61-indicatorContainer {\n        cursor: pointer;\n      }\n\n      .dtco-service-name {\n        font-size: var(--font-size-md);\n        font-weight: 600;\n        color: var(--color-maersk-blue);\n        padding: 5px 5px;\n        border-radius: 0px;\n      }\n\n      .dtco-run-btn {\n        margin-top: 24px;\n      }\n\n      .MultiSelect__menu-list {\n        padding: 5px !important;\n        margin: 0px !important;\n        border: 1px solid #e0e0e0;\n      }\n\n      .MultiSelect__option:last-child {\n        border-bottom: 1px solid #e0e0e0;\n      }\n\n      .btn-run {\n        height: 36px !important;\n      }\n\n      .MultiSelect__option:nth-child(1) {\n        border-top: 1px solid #e0e0e0;\n      }\n\n      .MultiSelect__option--is-selected {\n        background-color: #d7f2fb !important;\n      }\n\n      .MultiSelect__value-container {\n        height: 36px;\n        overflow-x: hidden !important;\n        overflow-y: auto;\n      }\n\n      .dtco-handle-group {\n        position: relative;\n        cursor: pointer;\n        font-weight: bold;\n        padding: 0px 12px;\n        align-content: center;\n        background: #f1f6f9;\n        border-radius: 0px;\n        margin-bottom: 4px;\n        height: 36px;\n        transition: background-color 0.3s;\n\n        .dtco-icon {\n          position: absolute;\n          top: 1px;\n          right: 10px;\n          font-size: 1.5rem;\n        }\n      }\n\n      .dtco-performa-option {\n        padding: 10px 12px;\n        border-radius: 4px;\n        margin-bottom: 2px;\n        transition: background-color 0.3s;\n      }\n\n      .dtco-performa-option-active {\n        background-color: var(--performa-option-active);\n      }\n\n      .dtco-performa-option-active:hover {\n        background-color: var(--performa-option-hover);\n      }\n\n      .dtco-performa-option-disabled {\n        background-color: var(--performa-option-disabled);\n        color: var(--performa-option-disabled-color) !important;\n        cursor: not-allowed;\n        pointer-events: all !important;\n      }\n    }\n  }\n}","@mixin header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: 36px;\n  font-weight: 300;\n  line-height: 40px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n@mixin sub-header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: var(--font-size-lg);\n  font-weight: 700;\n  line-height: 24px;\n  text-align: left;\n}\n@mixin modal-header-font {\n  font-family: Maersk Headline, sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: left;\n  margin: 0px;\n  padding: 0px 0px;\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
